import React, { useEffect, useRef, useState } from 'react';
import "../style/AppPages.css"
import { useTranslation } from 'react-i18next';
import { careGuidePages } from '../images/siteImages';
import Loading from '../components/Loading';

const preloadImage = (src) => new Promise((resolve) => {
    const img = new window.Image();
    img.onload = resolve;
    img.onerror = resolve;
    img.src = src;
});

const isMobileDevice = () =>
    typeof navigator !== 'undefined' &&
    (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));

const CareGuide = () => {
    const { t, i18n } = useTranslation();
    const printFrameRef = useRef(null);
    const printedSrcRef = useRef(null);
    const [pageUrls, setPageUrls] = useState([]);
    const [loading, setLoading] = useState(true);

    const langCode = i18n.language?.startsWith('fr') ? 'FR' : 'EN';
    const guideSrc = `${process.env.PUBLIC_URL}/PDFs/CareGuide${langCode}.pdf`;
    const printButtonSrc = `${process.env.PUBLIC_URL}/PDFs/Print_${langCode}.svg`;

    const handlePrintFrameLoad = () => {
        printedSrcRef.current = guideSrc;
        printFrameRef.current?.contentWindow?.print();
    };

    const handlePrintClick = () => {
        if (isMobileDevice()) {
            window.open(guideSrc, '_blank', 'noopener,noreferrer');
            return;
        }

        const iframe = printFrameRef.current;
        if (!iframe) return;

        if (printedSrcRef.current === guideSrc) {
            iframe.contentWindow?.print();
        } else {
            iframe.src = guideSrc;
        }
    };

    useEffect(() => {
        let cancelled = false;
        setPageUrls([]);
        setLoading(true);

        const loadPages = async () => {
            const urls = careGuidePages[langCode];

            await Promise.all(urls.map(preloadImage));

            if (cancelled) return;
            setPageUrls(urls);
            setLoading(false);
        };

        loadPages();

        return () => {
            cancelled = true;
        };
    }, [langCode]);

    return (
        <div className="page-padding-info" style={loading ? { minHeight: '100vh' } : undefined}>
            <Loading isVisible={loading} />
            {!loading && (
                <>
                    <div className="care-guide-container">
                        {pageUrls.map((url, i) => (
                            <img
                                key={url}
                                src={url}
                                className="care-guide-page"
                                alt={`${t("careGuide.title")} ${i + 1}/${pageUrls.length}`}
                            />
                            ))}
                            <img
                                src={printButtonSrc}
                                className="print-button"
                                alt="Print guide"
                                width="300"
                                height="auto"
                                onClick={handlePrintClick}
                            />
                        </div>
                        <iframe
                            ref={printFrameRef}
                            onLoad={handlePrintFrameLoad}
                            title="print-care-guide"
                            style={{ display: 'none' }}
                        />
                </>
            )}
        </div>
    );
}

export default CareGuide;
    